import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';
import _ from 'lodash';
import API from '../../app/api';
import MapState from '../../pages/ward/map/mapState';
import config from '../../app/config';

export class Permissions {
    static #_can_view_observations = 'AGYLE_CAN_VIEW_OBSERVATIONS';
    static #_can_enter_observations = 'AGYLE_CAN_ENTER_OBSERVATIONS';
    static #_can_set_hypercapnic_respiratory_failure = 'AGYLE_CAN_SET_HYPERCAPNIC_RESPIRATORY_FAILURE';
    static #_can_reduce_observaton_frequency = 'AGYLE_CAN_REDUCE_OBSERVATON_FREQUENCY';
    static #_can_increase_observation_frequency = 'AGYLE_CAN_INCREASE_OBSERVATION_FREQUENCY';
    static #_can_escalate_observation = 'AGYLE_CAN_ESCALATE_OBSERVATION';
    static #_can_enter_yn_sepsis = 'AGYLE_CAN_ENTER_YN_SEPSIS';
    static #_can_strike_through_observations = 'AGYLE_CAN_STRIKE_THROUGH_OBSERVATIONS';
    static #_can_strike_through_any_observations = 'AGYLE_CAN_STRIKE_THROUGH_ANY_OBSERVATIONS';
    static #_can_edit_frequency_cancel_observations = 'AGYLE_CAN_EDIT_FREQUENCY_CANCEL_OBSERVATIONS';
    static #_can_enter_noncontact_observations = 'AGYLE_CAN_ENTER_NONCONTACT_OBSERVATIONS';
    static #_can_confirm_escalation_message = 'AGYLE_CAN_CONFIRM_ESCALATION_MESSAGE';
    static #_can_drag_set_and_complete_tasks = 'AGYLE_CAN_DRAG_SET_AND_COMPLETE_TASKS';
    static #_can_remove_tasks = 'AGYLE_CAN_REMOVE_TASKS';
    static #_can_view_priorty_list = 'AGYLE_CAN_VIEW_PRIORTY_LIST';
    static #_can_edit_priorty_list = 'AGYLE_CAN_EDIT_PRIORTY_LIST';
    static #_can_open_patient_record = 'AGYLE_CAN_OPEN_PATIENT_RECORD';
    static #_can_manage_spaces = 'AGYLE_CAN_MANAGE_SPACES';
    static #_can_move_patients = 'AGYLE_CAN_MOVE_PATIENTS';
    static #_can_filter_patients = 'AGYLE_CAN_FILTER_PATIENTS';
    static #_can_view_triage = 'AGYLE_CAN_VIEW_TRIAGE';
    static #_can_manage_triage = 'AGYLE_CAN_MANAGE_TRIAGE';
    static #_can_set_clinician = 'AGYLE_CAN_SET_CLINICIAN';
    static #_can_view_clerking = 'AGYLE_CAN_VIEW_CLERKING';
    static #_can_manage_clerking = 'AGYLE_CAN_MANAGE_CLERKING';
    static #_can_view_referrals = 'AGYLE_CAN_VIEW_REFERRALS';
    static #_can_manage_referrals = 'AGYLE_CAN_MANAGE_REFERRALS';
    static #_can_view_nutrition = 'AGYLE_CAN_VIEW_NUTRITION';
    static #_can_manage_nutrtion = 'AGYLE_CAN_MANAGE_NUTRTION';
    static #_can_view_sepsis = 'AGYLE_CAN_VIEW_SEPSIS';
    static #_can_manage_sepsis = 'AGYLE_CAN_MANAGE_SEPSIS';
    static #_can_view_ceiltwd = 'AGYLE_CAN_VIEW_CEILTWD';
    static #_can_view_edit_ceiltwd = 'AGYLE_CAN_VIEW_EDIT_CEILTWD';
    static #_can_view_lower_limb_vte = 'AGYLE_CAN_VIEW_LOWER_LIMB_VTE';
    static #_can_manage_lower_limb_vte = 'AGYLE_CAN_MANAGE_LOWER_LIMB_VTE';
    static #_can_view_paediatric_safeguarding = 'AGYLE_CAN_VIEW_PAEDIATRIC_SAFEGUARDING';
    static #_can_manage_paediatric_safeguarding = 'AGYLE_CAN_MANAGE_PAEDIATRIC_SAFEGUARDING';
    static #_can_discharge = 'AGYLE_CAN_DISCHARGE';
    static #_can_only_discharge_edau = 'AGYLE_CAN_ONLY_DISCHARGE_EDAU';
    static #_can_access_clinical_notes = 'AGYLE_CAN_ACCESS_CLINICAL_NOTES';
    static #_can_add_clinical_notes = 'AGYLE_CAN_ADD_CLINICAL_NOTES';
    static #_can_edit_and_set_incorrect_clinical_notes = 'AGYLE_CAN_EDIT_AND_SET_INCORRECT_CLINICAL_NOTES';
    static #_can_view_attendance_history = 'AGYLE_CAN_VIEW_ATTENDANCE_HISTORY';
    static #_can_edit_attendance_history = 'AGYLE_CAN_EDIT_ATTENDANCE_HISTORY';
    static #_can_view_dpr_tab = 'AGYLE_CAN_VIEW_DPR_TAB';
    static #_can_view_household = 'AGYLE_CAN_VIEW_HOUSEHOLD';
    static #_can_manage_household = 'AGYLE_CAN_MANAGE_HOUSEHOLD';
    static #_can_view_ice_reports_info = 'AGYLE_CAN_VIEW_ICE_REPORTS_INFO';
    static #_can_view_clinical_letters = 'AGYLE_CAN_VIEW_CLINICAL_LETTERS';
    static #_is_ecds_admin = 'AGYLE_IS_ECDS_ADMIN';
    static #_can_view_ecds = 'AGYLE_CAN_VIEW_ECDS';
    static #_can_access_forms_library = 'AGYLE_CAN_ACCESS_FORMS_LIBRARY';
    static #_can_reset_ice_counter = 'AGYLE_CAN_RESET_ICE_COUNTER';
    static #_can_view_audits = 'AGYLE_CAN_VIEW_AUDITS';
    static #_can_menage_previous_values = 'AGYLE_CAN_MENAGE_PREVIOUS_VALUES';
    static #_can_view_urinalysis = 'AGYLE_CAN_VIEW_URINALYSIS';
    static #_can_add_urinalysis = 'AGYLE_CAN_ADD_URINALYSIS';
    static #_can_edit_urinalysis = 'AGYLE_CAN_EDIT_URINALYSIS';
    static #_can_move_from_edau = 'AGYLE_CAN_MOVE_FROM_EDAU';
    static #_can_admit_patient = 'AGYLE_CAN_ADMIT_PATIENT';
    static #_priority_view_for_junior_doctors = 'AGYLE_PRIORITY_VIEW_FOR_JUNIOR_DOCTORS';
    static #_can_ward_feedback = 'AGYLE_CAN_WARD_FEEDBACK';
    static #_can_view_bed_booking = 'AGYLE_CAN_VIEW_BED_BOOKING';
    static #_can_remove_from_bedbooking = 'AGYLE_CAN_REMOVE_FROM_BEDBOOKING';
    static #_can_access_merges_page = 'CAN_ACCESS_MERGES_PAGE';
    static #_can_access_pin_admin = 'CAN_ACCESS_PIN_ADMIN';
    static #_can_manage_pins = 'CAN_MANAGE_PINS';
    static #_can_confirm_demographics = 'AGYLE_CAN_CONFIRM_DEMOGRAPHICS';
    static #_can_discharge_temporary = 'AGYLE_CAN_DISCHARGE_TEMPORARY';
    static #_can_access_hl7dashboard = 'CAN_ACCESS_HL7DASHBOARD';
    static #_can_access_dictionaries = 'CAN_ACCESS_DICTIONARIES';
    static #_can_access_reports = 'CAN_ACCESS_REPORTS';
    static #_can_access_statistics = 'CAN_ACCESS_STATISTICS';
    static #_can_add_announcement = 'CAN_ADD_ANNOUNCEMENT';
    static #_can_access_admin_page = 'CAN_ACCESS_ADMIN_PAGE';
    static #_can_access_fhir_dashboard = 'CAN_ACCESS_FHIR_DASHBOARD';
    static #_can_access_ph = 'AGYLE_CAN_ACCESS_PH';
    static #_can_access_rbh = 'AGYLE_CAN_ACCESS_RBH';
    static #_can_edit_post_discharge_form = 'AGYLE_CAN_EDIT_POST_DISCHARGE_FORM';
    static #_can_view_only = 'AGYLE_CAN_VIEW_ONLY';
    static #_can_add_prescription = 'AGYLE_CAN_ADD_PRESCRIPTION';
    static #_can_print_document = 'CAN_PRINT_DOCUMENT';
    static #_can_print_and_download = 'CAN_PRINT_AND_DOWNLOAD';
    static #_can_view_manage_bedas_calendar = 'AGYLE_CAN_MANAGE_BEDAS_CALENDAR';
    static #_can_manual_manage_bedas_calendar = 'AGYLE_CAN_MANUAL_MANAGE_BEDAS_CALENDAR';
    static #_can_access_mct_admin = 'AGYLE_CAN_ACCESS_MCT_ADMIN';
    static #_can_manage_ward_map = 'AGYLE_CAN_MANAGE_WARD_MAP';
    static #_can_publish_ward_map = 'AGYLE_CAN_PUBLISH_WARD_MAP';
    static #_can_view_only_ward_map = 'AGYLE_CAN_VIEW_ONLY_WARD_MAP';
    static #_can_config_system = 'AGYLE_CAN_CONFIG_SYSTEM';
    static #_can_manage_escalation = 'AGYLE_CAN_MANAGE_ESCALATION';
    static #_agyle_can_verificationofdeath = 'AGYLE_CAN_VERIFICATIONOFDEATH';
    static #_agyle_demo = 'AGYLE_DEMO';
    static #_agyle_can_manage_frailty = 'AGYLE_CAN_MANAGE_FRAILITY';
    static #_agyle_can_view_frailty = 'AGYLE_CAN_VIEW_FRAILITY';
    static #_agyle_can_manage_emed3 = 'AGYLE_CAN_MANAGE_EMED3';
    static #_agyle_can_manage_admitting_consultants = 'AGYLE_CAN_MANAGE_ADMITTING_CONSULTANTS';
    static #_agyle_can_2nd_sign = 'AGYLE_CAN_2ND_SIGN';
    static #_can_manage_treatment_boards = 'AGYLE_CAN_MANAGE_TREATMENTBOARDS';
    static #_can_view_treatment_boards = 'AGYLE_CAN_VIEW_TREATMENTBOARDS';
    static #_can_manage_ptlist = 'AGYLE_CAN_MANAGE_PTLIST';
    static #_can_see_canceled = 'AGYLE_SEE_CANCELED';

    //SCHEDULER
    static #_agyle_can_access_scheduler = 'AGYLE_CAN_ACCESS_SCHEDULER';
    static #_agyle_can_book_scheduler = 'AGYLE_CAN_BOOK_SCHEDULER';
    static #_agyle_can_manage_sessions_scheduler = 'AGYLE_CAN_MANAGE_SESSIONS_SCHEDULER';
    static #_agyle_can_manage_slots_scheduler = 'AGYLE_CAN_MANAGE_SLOTS_SCHEDULER';

    //BOOK ADMISSION
    static #_ba_can_manage_t_admissions = 'BA_CAN_MANAGE_T_ADMISSIONS';
    static #_ba_can_add_new_t_session = 'BA_CAN_ADD_NEW_T_SESSION';
    static #_ba_can_manage_sessions = 'BA_CAN_MANAGE_SESSIONS';
    static #_ba_can_manage_t_locked_slots = 'BA_CAN_MANAGE_T_LOCKED_SLOTS';
    static #_ba_can_manage_worklist = 'BA_CAN_MANAGE_WORKLIST';
    static #_ba_can_manage_tci_ul = 'BA_CAN_MANAGE_TCI_UL';
    static #_ba_can_manage_t_tci_sl = 'BA_CAN_MANAGE_T_TCI_SL';
    static #_ba_can_manage_decisions = 'BA_CAN_MANAGE_DECISIONS';
    static #_ba_can_manage_contact_journal = 'BA_CAN_MANAGE_CONTACT_JOURNAL';
    static #_ba_is_theatres_admin = 'BA_IS_THEATRES_ADMIN';
    static #_ba_can_manage_mdu_admissions = 'BA_CAN_MANAGE_MDU_ADMISSIONS';
    static #_ba_can_print_new_mdu_admission = 'BA_CAN_PRINT_NEW_MDU_ADMISSION';
    static #_ba_can_add_mdu_session = 'BA_CAN_ADD_MDU_SESSION';
    static #_ba_can_manage_mdu_sessions = 'BA_CAN_MANAGE_MDU_SESSIONS';
    static #_ba_can_manage_mdu_locked_slots = 'BA_CAN_MANAGE_MDU_LOCKED_SLOTS';
    static #_ba_can_manage_mdu_ul = 'BA_CAN_MANAGE_MDU_UL';
    static #_ba_can_print_mdu_from_ul = 'BA_CAN_PRINT_MDU_FROM_UL';
    static #_ba_mdu_book_patient_into_session = 'BA_MDU_BOOK_PATIENT_INTO_SESSION';
    static #_ba_can_manage_mdu_on_sl = 'BA_CAN_MANAGE_MDU_ON_SL';
    static #_ba_can_manage_mdu_decisions = 'BA_CAN_MANAGE_MDU_DECISIONS';
    static #_ba_can_manage_mdu_contact_journal = 'BA_CAN_MANAGE_MDU_CONTACT_JOURNAL';
    static #_ba_is_mdu_admin = 'BA_IS_MDU_ADMIN';
    static #_ba_can_access_ba = 'BA_CAN_ACCESS_BA';
    static #_ba_can_schedule_directly = 'BA_CAN_SCHEDULE_DIRECTLY';
    static #_ba_can_print = 'BA_CAN_PRINT';
    static #_bm_can_manage_bed_request_from = 'BM_CAN_MANAGE_BED_REQUEST_FROM';
    //EYONIX
    static #_can_view_patient_record = 'CAN_VIEW_PATIENT_RECORD';
    static #_can_modify_patient_record = 'CAN_MODIFY_PATIENT_RECORD';
    static #_can_upload_document = 'CAN_UPLOAD_DOCUMENT'; //exists in old permissions
    static #_can_delete_document = 'CAN_DELETE_DOCUMENT';
    static #_can_move_to_hp = 'CAN_MOVE_TO_HP';
    static #_can_delete_doc_hp = 'CAN_DELETE_DOC_HP';
    static #_is_research = 'IS_RESEARCH';
    //static #_can_print_and_download = 'CAN_PRINT_AND_DOWNLOAD'; //exists in old permissions
    static #_can_access_holding_pen = 'CAN_ACCESS_HOLDING_PEN';
    static #_can_view_vip = 'CAN_VIEW_VIP';
    static #_can_view_vip_supervised = 'CAN_VIEW_VIP_SUPERVISED';
    static #_can_create_patient = 'CAN_CREATE_PATIENT';
    static #_can_edit_patient = 'CAN_EDIT_PATIENT';

    static get BA_CAN_MANAGE_T_ADMISSIONS() {
        return this.#_ba_can_manage_t_admissions;
    }
    static get BA_CAN_ADD_NEW_T_SESSION() {
        return this.#_ba_can_add_new_t_session;
    }
    static get BA_CAN_MANAGE_SESSIONS() {
        return this.#_ba_can_manage_sessions;
    }
    static get BA_CAN_MANAGE_T_LOCKED_SLOTS() {
        return this.#_ba_can_manage_t_locked_slots;
    }
    static get BA_CAN_MANAGE_WORKLIST() {
        return this.#_ba_can_manage_worklist;
    }
    static get BA_CAN_MANAGE_TCI_UL() {
        return this.#_ba_can_manage_tci_ul;
    }
    static get BA_CAN_MANAGE_T_TCI_SL() {
        return this.#_ba_can_manage_t_tci_sl;
    }
    static get BA_CAN_MANAGE_DECISIONS() {
        return this.#_ba_can_manage_decisions;
    }
    static get BA_CAN_MANAGE_CONTACT_JOURNAL() {
        return this.#_ba_can_manage_contact_journal;
    }
    static get BA_IS_THEATRES_ADMIN() {
        return this.#_ba_is_theatres_admin;
    }
    static get BA_CAN_MANAGE_MDU_ADMISSIONS() {
        return this.#_ba_can_manage_mdu_admissions;
    }
    static get BA_CAN_PRINT_NEW_MDU_ADMISSION() {
        return this.#_ba_can_print_new_mdu_admission;
    }
    static get BA_CAN_ADD_MDU_SESSION() {
        return this.#_ba_can_add_mdu_session;
    }
    static get BA_CAN_MANAGE_MDU_SESSIONS() {
        return this.#_ba_can_manage_mdu_sessions;
    }
    static get BA_CAN_MANAGE_MDU_LOCKED_SLOTS() {
        return this.#_ba_can_manage_mdu_locked_slots;
    }
    static get BA_CAN_MANAGE_MDU_UL() {
        return this.#_ba_can_manage_mdu_ul;
    }
    static get BA_CAN_PRINT_MDU_FROM_UL() {
        return this.#_ba_can_print_mdu_from_ul;
    }
    static get BA_CAN_MANAGE_MDU_ON_SL() {
        return this.#_ba_can_manage_mdu_on_sl;
    }
    static get BA_MDU_BOOK_PATIENT_INTO_SESSION() {
        return this.#_ba_mdu_book_patient_into_session;
    }
    static get BA_CAN_MANAGE_MDU_DECISIONS() {
        return this.#_ba_can_manage_mdu_decisions;
    }
    static get BA_CAN_MANAGE_MDU_CONTACT_JOURNAL() {
        return this.#_ba_can_manage_mdu_contact_journal;
    }
    static get BA_IS_MDU_ADMIN() {
        return this.#_ba_is_mdu_admin;
    }
    static get BA_CAN_ACCESS_BA() {
        return this.#_ba_can_access_ba;
    }
    static get BA_CAN_SCHEDULE_DIRECTLY() {
        return this.#_ba_can_schedule_directly;
    }
    static get BA_CAN_PRINT() {
        return this.#_ba_can_print;
    }

    static get BM_CAN_MANAGE_BED_REQUEST_FROM() {
        return this.#_bm_can_manage_bed_request_from;
    }

    static get CAN_PRINT_DOCUMENT() {
        return this.#_can_print_document;
    }
    static get CAN_PRINT_AND_DOWNLOAD() {
        return this.#_can_print_and_download;
    }
    static get AGYLE_CAN_VIEW_OBSERVATIONS() {
        return this.#_can_view_observations;
    }
    static get AGYLE_CAN_ENTER_OBSERVATIONS() {
        return this.#_can_enter_observations;
    }
    static get AGYLE_CAN_SET_HYPERCAPNIC_RESPIRATORY_FAILURE() {
        return this.#_can_set_hypercapnic_respiratory_failure;
    }
    static get AGYLE_CAN_REDUCE_OBSERVATON_FREQUENCY() {
        return this.#_can_reduce_observaton_frequency;
    }
    static get AGYLE_CAN_INCREASE_OBSERVATION_FREQUENCY() {
        return this.#_can_increase_observation_frequency;
    }
    static get AGYLE_CAN_ESCALATE_OBSERVATION() {
        return this.#_can_escalate_observation;
    }
    static get AGYLE_CAN_ENTER_YN_SEPSIS() {
        return this.#_can_enter_yn_sepsis;
    }
    static get AGYLE_CAN_STRIKE_THROUGH_OBSERVATIONS() {
        return this.#_can_strike_through_observations;
    }
    static get AGYLE_CAN_STRIKE_THROUGH_ANY_OBSERVATIONS() {
        return this.#_can_strike_through_any_observations;
    }
    static get AGYLE_CAN_EDIT_FREQUENCY_CANCEL_OBSERVATIONS() {
        return this.#_can_edit_frequency_cancel_observations;
    }
    static get AGYLE_CAN_ENTER_NONCONTACT_OBSERVATIONS() {
        return this.#_can_enter_noncontact_observations;
    }
    static get AGYLE_CAN_CONFIRM_ESCALATION_MESSAGE() {
        return this.#_can_confirm_escalation_message;
    }
    static get AGYLE_CAN_DRAG_SET_AND_COMPLETE_TASKS() {
        return this.#_can_drag_set_and_complete_tasks;
    }
    static get AGYLE_CAN_REMOVE_TASKS() {
        return this.#_can_remove_tasks;
    }
    static get AGYLE_CAN_VIEW_PRIORTY_LIST() {
        return this.#_can_view_priorty_list;
    }
    static get AGYLE_CAN_EDIT_PRIORTY_LIST() {
        return this.#_can_edit_priorty_list;
    }
    static get AGYLE_CAN_OPEN_PATIENT_RECORD() {
        return this.#_can_open_patient_record;
    }
    static get AGYLE_CAN_MANAGE_SPACES() {
        return this.#_can_manage_spaces;
    }
    static get AGYLE_CAN_MOVE_PATIENTS() {
        return this.#_can_move_patients;
    }
    static get AGYLE_CAN_FILTER_PATIENTS() {
        return this.#_can_filter_patients;
    }
    static get AGYLE_CAN_VIEW_TRIAGE() {
        return this.#_can_view_triage;
    }
    static get AGYLE_CAN_MANAGE_TRIAGE() {
        return this.#_can_manage_triage;
    }
    static get AGYLE_CAN_SET_CLINICIAN() {
        return this.#_can_set_clinician;
    }
    static get AGYLE_CAN_VIEW_CLERKING() {
        return this.#_can_view_clerking;
    }
    static get AGYLE_CAN_MANAGE_CLERKING() {
        return this.#_can_manage_clerking;
    }
    static get AGYLE_CAN_VIEW_REFERRALS() {
        return this.#_can_view_referrals;
    }
    static get AGYLE_CAN_MANAGE_REFERRALS() {
        return this.#_can_manage_referrals;
    }
    static get AGYLE_CAN_VIEW_NUTRITION() {
        return this.#_can_view_nutrition;
    }
    static get AGYLE_CAN_MANAGE_NUTRTION() {
        return this.#_can_manage_nutrtion;
    }
    static get AGYLE_CAN_VIEW_SEPSIS() {
        return this.#_can_view_sepsis;
    }
    static get AGYLE_CAN_MANAGE_SEPSIS() {
        return this.#_can_manage_sepsis;
    }
    static get AGYLE_CAN_VIEW_CEILTWD() {
        return this.#_can_view_ceiltwd;
    }
    static get AGYLE_CAN_VIEW_EDIT_CEILTWD() {
        return this.#_can_view_edit_ceiltwd;
    }
    static get AGYLE_CAN_VIEW_LOWER_LIMB_VTE() {
        return this.#_can_view_lower_limb_vte;
    }
    static get AGYLE_CAN_MANAGE_LOWER_LIMB_VTE() {
        return this.#_can_manage_lower_limb_vte;
    }
    static get AGYLE_CAN_VIEW_PAEDIATRIC_SAFEGUARDING() {
        return this.#_can_view_paediatric_safeguarding;
    }
    static get AGYLE_CAN_MANAGE_PAEDIATRIC_SAFEGUARDING() {
        return this.#_can_manage_paediatric_safeguarding;
    }
    static get AGYLE_CAN_DISCHARGE() {
        return this.#_can_discharge;
    }
    static get AGYLE_CAN_ONLY_DISCHARGE_EDAU() {
        return this.#_can_only_discharge_edau;
    }
    static get AGYLE_CAN_ACCESS_CLINICAL_NOTES() {
        return this.#_can_access_clinical_notes;
    }
    static get AGYLE_CAN_ADD_CLINICAL_NOTES() {
        return this.#_can_add_clinical_notes;
    }
    static get AGYLE_CAN_EDIT_AND_SET_INCORRECT_CLINICAL_NOTES() {
        return this.#_can_edit_and_set_incorrect_clinical_notes;
    }
    static get AGYLE_CAN_VIEW_ATTENDANCE_HISTORY() {
        return this.#_can_view_attendance_history;
    }
    static get AGYLE_CAN_EDIT_ATTENDANCE_HISTORY() {
        return this.#_can_edit_attendance_history;
    }
    static get AGYLE_CAN_VIEW_DPR_TAB() {
        return this.#_can_view_dpr_tab;
    }
    static get AGYLE_CAN_VIEW_HOUSEHOLD() {
        return this.#_can_view_household;
    }
    static get AGYLE_CAN_MANAGE_HOUSEHOLD() {
        return this.#_can_manage_household;
    }
    static get AGYLE_CAN_VIEW_ICE_REPORTS_INFO() {
        return this.#_can_view_ice_reports_info;
    }
    static get AGYLE_CAN_VIEW_CLINICAL_LETTERS() {
        return this.#_can_view_clinical_letters;
    }
    static get AGYLE_IS_ECDS_ADMIN() {
        return this.#_is_ecds_admin;
    }
    static get AGYLE_CAN_VIEW_ECDS() {
        return this.#_can_view_ecds;
    }
    static get AGYLE_CAN_ACCESS_FORMS_LIBRARY() {
        return this.#_can_access_forms_library;
    }
    static get AGYLE_CAN_RESET_ICE_COUNTER() {
        return this.#_can_reset_ice_counter;
    }
    static get AGYLE_CAN_VIEW_AUDITS() {
        return this.#_can_view_audits;
    }
    static get AGYLE_CAN_MENAGE_PREVIOUS_VALUES() {
        return this.#_can_menage_previous_values;
    }
    static get AGYLE_CAN_VIEW_URINALYSIS() {
        return this.#_can_view_urinalysis;
    }
    static get AGYLE_CAN_ADD_URINALYSIS() {
        return this.#_can_add_urinalysis;
    }
    static get AGYLE_CAN_EDIT_URINALYSIS() {
        return this.#_can_edit_urinalysis;
    }
    static get AGYLE_CAN_MOVE_FROM_EDAU() {
        return this.#_can_move_from_edau;
    }
    static get AGYLE_CAN_ADMIT_PATIENT() {
        return this.#_can_admit_patient;
    }
    static get AGYLE_PRIORITY_VIEW_FOR_JUNIOR_DOCTORS() {
        return this.#_priority_view_for_junior_doctors;
    }
    static get AGYLE_CAN_WARD_FEEDBACK() {
        return this.#_can_ward_feedback;
    }
    static get AGYLE_CAN_VIEW_BED_BOOKING() {
        return this.#_can_view_bed_booking;
    }
    static get AGYLE_CAN_REMOVE_FROM_BEDBOOKING() {
        return this.#_can_remove_from_bedbooking;
    }
    static get AGYLE_CAN_CONFIRM_DEMOGRAPHICS() {
        return this.#_can_confirm_demographics;
    }
    static get AGYLE_CAN_DISCHARGE_TEMPORARY() {
        return this.#_can_discharge_temporary;
    }
    static get CAN_ACCESS_MERGES_PAGE() {
        return this.#_can_access_merges_page;
    }
    static get CAN_ACCESS_PIN_ADMIN() {
        return this.#_can_access_pin_admin;
    }
    static get CAN_MANAGE_PINS() {
        return this.#_can_manage_pins;
    }
    static get CAN_ACCESS_HL7DASHBOARD() {
        return this.#_can_access_hl7dashboard;
    }
    static get CAN_ACCESS_FHIR_DASHBOARD() {
        return this.#_can_access_fhir_dashboard;
    }
    static get CAN_ACCESS_DICTIONARIES() {
        return this.#_can_access_dictionaries;
    }
    static get CAN_ACCESS_REPORTS() {
        return this.#_can_access_reports;
    }
    static get CAN_ACCESS_STATISTICS() {
        return this.#_can_access_statistics;
    }
    static get CAN_ADD_ANNOUNCEMENT() {
        return this.#_can_add_announcement;
    }
    static get CAN_ACCESS_ADMIN_PAGE() {
        return this.#_can_access_admin_page;
    }
    static get AGYLE_CAN_ACCESS_PH() {
        return this.#_can_access_ph;
    }
    static get AGYLE_CAN_ACCESS_RBH() {
        return this.#_can_access_rbh;
    }
    static get AGYLE_CAN_EDIT_POST_DISCHARGE_FORM() {
        return this.#_can_edit_post_discharge_form;
    }
    static get AGYLE_CAN_VIEW_ONLY() {
        return this.#_can_view_only;
    }
    static get AGYLE_CAN_ADD_PRESCRIPTION() {
        return this.#_can_add_prescription;
    }
    static get AGYLE_CAN_MANAGE_BEDAS_CALENDAR() {
        return this.#_can_view_manage_bedas_calendar;
    }
    static get AGYLE_CAN_MANUAL_MANAGE_BEDAS_CALENDAR() {
        return this.#_can_manual_manage_bedas_calendar;
    }
    static get AGYLE_CAN_ACCESS_MCT_ADMIN() {
        return this.#_can_access_mct_admin;
    }
    static get AGYLE_CAN_MANAGE_WARD_MAP() {
        return this.#_can_manage_ward_map;
    }
    static get AGYLE_CAN_PUBLISH_WARD_MAP() {
        return this.#_can_publish_ward_map;
    }
    static get AGYLE_CAN_VIEW_ONLY_WARD_MAP() {
        return this.#_can_view_only_ward_map;
    }
    static get AGYLE_CAN_CONFIG_SYSTEM() {
        return this.#_can_config_system;
    }
    static get AGYLE_CAN_MANAGE_ESCALATION() {
        return this.#_can_manage_escalation;
    }
    static get AGYLE_CAN_VIEW_TREATMENTBOARDS() {
        return this.#_can_view_treatment_boards;
    }
    static get AGYLE_CAN_MANAGE_TREATMENTBOARDS() {
        return this.#_can_manage_treatment_boards;
    }
    static get AGYLE_CAN_MANAGE_PTLIST() {
        return this.#_can_manage_ptlist;
    }
    static get AGYLE_CAN_SEE_CANCELED() {
        return this.#_can_see_canceled;
    }

    static get CAN_VIEW_PATIENT_RECORD() {
        return this.#_can_view_patient_record;
    }
    static get CAN_MODIFY_PATIENT_RECORD() {
        return this.#_can_modify_patient_record;
    }
    static get CAN_DELETE_DOCUMENT() {
        return this.#_can_delete_document;
    }
    static get CAN_MOVE_TO_HP() {
        return this.#_can_move_to_hp;
    }
    static get IS_RESEARCH() {
        return this.#_is_research;
    }
    static get CAN_UPLOAD_DOCUMENT() {
        return this.#_can_upload_document;
    }
    static get CAN_ACCESS_HOLDING_PEN() {
        return this.#_can_access_holding_pen;
    }
    static get CAN_VIEW_VIP() {
        return this.#_can_view_vip;
    }
    static get CAN_VIEW_VIP_SUPERVISED() {
        return this.#_can_view_vip_supervised;
    }
    static get CAN_CREATE_PATIENT() {
        return this.#_can_create_patient;
    }
    static get CAN_EDIT_PATIENT() {
        return this.#_can_edit_patient;
    }
    static get AGYLE_CAN_VERIFICATIONOFDEATH() {
        return this.#_agyle_can_verificationofdeath;
    }
    static get AGYLE_DEMO() {
        return this.#_agyle_demo;
    }
    static get AGYLE_CAN_MANAGE_EMED3() {
        return this.#_agyle_can_manage_emed3;
    }
    static get AGYLE_CAN_MANAGE_ADMITTING_CONSULTANTS() {
        return this.#_agyle_can_manage_admitting_consultants;
    }
    static get CAN_DELETE_DOC_HP() {
        return this.#_can_delete_doc_hp;
    }
    static get AGYLE_CAN_2ND_SIGN() {
        return this.#_agyle_can_2nd_sign;
    }

    static get AGYLE_CAN_ACCESS_SCHEDULER() {
        return this.#_agyle_can_access_scheduler;
    }
    static get AGYLE_CAN_BOOK_SCHEDULER() {
        return this.#_agyle_can_book_scheduler;
    }
    static get AGYLE_CAN_MANAGE_SESSIONS_SCHEDULER() {
        return this.#_agyle_can_manage_sessions_scheduler;
    }
    static get AGYLE_CAN_MANAGE_SLOTS_SCHEDULER() {
        return this.#_agyle_can_manage_slots_scheduler;
    }

    static get AGYLE_CAN_VIEW_FRAILITY() {
        return this.#_agyle_can_view_frailty;
    }

    static get AGYLE_CAN_MANAGE_FRAILITY() {
        return this.#_agyle_can_manage_frailty;
    }

    static get PERMISSIONS_LIST() {
        return [
            'AGYLE_CAN_ENTER_OBSERVATIONS',
            'AGYLE_CAN_SET_HYPERCAPNIC_RESPIRATORY_FAILURE',
            'AGYLE_CAN_REDUCE_OBSERVATON_FREQUENCY',
            'AGYLE_CAN_INCREASE_OBSERVATION_FREQUENCY',
            'AGYLE_CAN_ESCALATE_OBSERVATION',
            'AGYLE_CAN_ENTER_YN_SEPSIS',
            'AGYLE_CAN_STRIKE_THROUGH_OBSERVATIONS',
            'AGYLE_CAN_STRIKE_THROUGH_ANY_OBSERVATIONS',
            'AGYLE_CAN_EDIT_FREQUENCY_CANCEL_OBSERVATIONS',
            'AGYLE_CAN_ENTER_NONCONTACT_OBSERVATIONS',
            'AGYLE_CAN_VIEW_OBSERVATIONS',
            'AGYLE_CAN_CONFIRM_ESCALATION_MESSAGE',
            'AGYLE_CAN_DRAG_SET_AND_COMPLETE_TASKS',
            'AGYLE_CAN_REMOVE_TASKS',
            'AGYLE_CAN_VIEW_PRIORTY_LIST',
            'AGYLE_CAN_EDIT_PRIORTY_LIST',
            'AGYLE_CAN_OPEN_PATIENT_RECORD',
            'AGYLE_CAN_MANAGE_SPACES',
            'AGYLE_CAN_MOVE_PATIENTS',
            'AGYLE_CAN_FILTER_PATIENTS',
            'AGYLE_CAN_VIEW_TRIAGE',
            'AGYLE_CAN_MANAGE_TRIAGE',
            'AGYLE_CAN_SET_CLINICIAN',
            'AGYLE_CAN_VIEW_CLERKING',
            'AGYLE_CAN_MANAGE_CLERKING',
            'AGYLE_CAN_VIEW_REFERRALS',
            'AGYLE_CAN_MANAGE_REFERRALS',
            'AGYLE_CAN_VIEW_NUTRITION',
            'AGYLE_CAN_MANAGE_NUTRTION',
            'AGYLE_CAN_VIEW_SEPSIS',
            'AGYLE_CAN_MANAGE_SEPSIS',
            'AGYLE_CAN_VIEW_CEILTWD',
            'AGYLE_CAN_VIEW_EDIT_CEILTWD',
            'AGYLE_CAN_VIEW_LOWER_LIMB_VTE',
            'AGYLE_CAN_MANAGE_LOWER_LIMB_VTE',
            'AGYLE_CAN_VIEW_PAEDIATRIC_SAFEGUARDING',
            'AGYLE_CAN_MANAGE_PAEDIATRIC_SAFEGUARDING',
            'AGYLE_CAN_DISCHARGE',
            'AGYLE_CAN_ONLY_DISCHARGE_EDAU',
            'AGYLE_CAN_ACCESS_CLINICAL_NOTES',
            'AGYLE_CAN_ADD_CLINICAL_NOTES',
            'AGYLE_CAN_EDIT_AND_SET_INCORRECT_CLINICAL_NOTES',
            'AGYLE_CAN_VIEW_ATTENDANCE_HISTORY',
            'AGYLE_CAN_EDIT_ATTENDANCE_HISTORY',
            'AGYLE_CAN_VIEW_DPR_TAB',
            'AGYLE_CAN_VIEW_HOUSEHOLD',
            'AGYLE_CAN_MANAGE_HOUSEHOLD',
            'AGYLE_CAN_VIEW_ICE_REPORTS_INFO',
            'AGYLE_CAN_VIEW_CLINICAL_LETTERS',
            'AGYLE_CAN_EDIT_POST_DISCHARGE_FORM',
            'AGYLE_IS_ECDS_ADMIN',
            'AGYLE_CAN_VIEW_ECDS',
            'AGYLE_CAN_ACCESS_FORMS_LIBRARY',
            'AGYLE_CAN_RESET_ICE_COUNTER',
            'AGYLE_CAN_VIEW_AUDITS',
            'AGYLE_CAN_MENAGE_PREVIOUS_VALUES',
            'AGYLE_CAN_VIEW_URINALYSIS',
            'AGYLE_CAN_ADD_URINALYSIS',
            'AGYLE_CAN_EDIT_URINALYSIS',
            'AGYLE_CAN_MOVE_FROM_EDAU',
            'AGYLE_CAN_ADMIT_PATIENT',
            'AGYLE_PRIORITY_VIEW_FOR_JUNIOR_DOCTORS',
            'AGYLE_CAN_WARD_FEEDBACK',
            'AGYLE_CAN_VIEW_BED_BOOKING',
            'AGYLE_CAN_REMOVE_FROM_BEDBOOKING',
            'AGYLE_CAN_CONFIRM_DEMOGRAPHICS',
            'AGYLE_CAN_DISCHARGE_TEMPORARY',
            'CAN_ACCESS_MERGES_PAGE',
            'CAN_ACCESS_PIN_ADMIN',
            'CAN_MANAGE_PINS',
            'CAN_ACCESS_HL7DASHBOARD',
            'CAN_ACCESS_DICTIONARIES',
            'CAN_ADD_ANNOUNCEMENT',
            'CAN_ACCESS_ADMIN_PAGE',
            'CAN_ACCESS_REPORTS',
            'AGYLE_CAN_ACCESS_RBH',
            'AGYLE_CAN_ACCESS_PH',
            'CAN_ACCESS_FHIR_DASHBOARD',
            'AGYLE_CAN_VIEW_ONLY',
            'AGYLE_CAN_ADD_PRESCRIPTION',
            'AGYLE_CAN_MANAGE_BEDAS_CALENDAR',
            'AGYLE_CAN_MANUAL_MANAGE_BEDAS_CALENDAR',
            'AGYLE_CAN_ACCESS_MCT_ADMIN',
            'AGYLE_CAN_MANAGE_WARD_MAP',
            'AGYLE_CAN_PUBLISH_WARD_MAP',
            'AGYLE_CAN_VIEW_ONLY_WARD_MAP',
            'AGYLE_CAN_CONFIG_SYSTEM',
            'AGYLE_CAN_MANAGE_ESCALATION',
            'AGYLE_CAN_VERIFICATIONOFDEATH',
            'AGYLE_DEMO',
            'AGYLE_CAN_VIEW_FRAILITY',
            'AGYLE_CAN_MANAGE_FRAILITY',
            'CAN_ACCESS_STATISTICS',
            'AGYLE_CAN_MANAGE_EMED3',
            'AGYLE_CAN_MANAGE_ADMITTING_CONSULTANTS',
            'AGYLE_CAN_2ND_SIGN',
            'AGYLE_CAN_VIEW_TREATMENTBOARDS',
            'AGYLE_CAN_MANAGE_TREATMENTBOARDS',
            'AGYLE_CAN_MANAGE_PTLIST',
            'AGYLE_CAN_SEE_CANCELED',

            'AGYLE_CAN_ACCESS_SCHEDULER',
            'AGYLE_CAN_BOOK_SCHEDULER',
            'AGYLE_CAN_MANAGE_SESSIONS_SCHEDULER',
            'AGYLE_CAN_MANAGE_SLOTS_SCHEDULER',

            'BA_CAN_MANAGE_T_ADMISSIONS',
            'BA_CAN_ADD_NEW_T_SESSION',
            'BA_CAN_MANAGE_SESSIONS',
            'BA_CAN_MANAGE_T_LOCKED_SLOTS',
            'BA_CAN_MANAGE_WORKLIST',
            'BA_CAN_MANAGE_TCI_UL',
            'BA_CAN_MANAGE_T_TCI_SL',
            'BA_CAN_MANAGE_DECISIONS',
            'BA_CAN_MANAGE_CONTACT_JOURNAL',
            'BA_IS_THEATRES_ADMIN',
            'BA_CAN_MANAGE_MDU_ADMISSIONS',
            'BA_CAN_PRINT_NEW_MDU_ADMISSION',
            'BA_CAN_ADD_MDU_SESSION',
            'BA_CAN_MANAGE_MDU_SESSIONS',
            'BA_CAN_MANAGE_MDU_LOCKED_SLOTS',
            'BA_CAN_MANAGE_MDU_UL',
            'BA_CAN_PRINT_MDU_FROM_UL',
            'BA_MDU_BOOK_PATIENT_INTO_SESSION',
            'BA_CAN_MANAGE_MDU_ON_SL',
            'BA_CAN_MANAGE_MDU_DECISIONS',
            'BA_CAN_MANAGE_MDU_CONTACT_JOURNAL',
            'BA_IS_MDU_ADMIN',
            'BA_CAN_ACCESS_BA',
            'BM_CAN_MANAGE_BED_REQUEST_FROM',

            'CAN_VIEW_PATIENT_RECORD',
            'CAN_MODIFY_PATIENT_RECORD',
            'CAN_DELETE_DOCUMENT',
            'CAN_UPLOAD_DOCUMENT',
            'CAN_ACCESS_HOLDING_PEN',
            'CAN_VIEW_VIP',
            'CAN_VIEW_VIP_SUPERVISED',
            'CAN_CREATE_PATIENT',
            'CAN_MOVE_TO_HP',
            'CAN_DELETE_DOC_HP',
            'IS_RESEARCH',
            'CAN_DELETE_DOC_HP',
        ];
    }
}

export const userSlice = createSlice({
    name: 'user',
    initialState: {
        userData: {},
        vipPatientIdAccessGranted: {},
        loadingUser: false,
    },
    reducers: {
        setUser: (state, preference) => {
            state.userData = _.merge(state.userData, preference.payload);
            MapState.user = preference.payload;
            Object.keys(state.vipPatientIdAccessGranted).forEach((oldPatientIds) => {
                delete state.user.vipPatientIdAccessGranted[oldPatientIds];
            });
        },
        setVipPatientGranted: (state, patientId) => {
            let timeoutSeconds = 1200;
            if (config.modules?.patient?.vipPatientAccessGrantTimeInSec)
                timeoutSeconds = config.modules?.patient?.vipPatientAccessGrantTimeInSec;
            Object.keys(state.vipPatientIdAccessGranted).forEach((oldPatientIds) => {
                delete state.user.vipPatientIdAccessGranted[oldPatientIds];
            });
            state.vipPatientIdAccessGranted[patientId.payload] = moment().add(timeoutSeconds, 'second');
        },
        setLoadingUser: (state, data) => {
            state.loadingUser = data.payload;
        },
    },
});

export const { setUser, setVipPatientGranted, setLoadingUser } = userSlice.actions;

export const user = (state) => state.user.userData;
export const loadingUser = (state) => state.user.loadingUser;

export const vipPatientGranted = (patientId) => (dispatch, getState) => {
    if (getState().user.vipPatientIdAccessGranted.hasOwnProperty(patientId)) {
        if (moment().isAfter(getState().user.vipPatientIdAccessGranted[patientId]))
            delete getState().user.vipPatientIdAccessGranted[patientId];
    }
    return getState().user.vipPatientIdAccessGranted.hasOwnProperty(patientId);
};

export const loadUser =
    (loading = true) =>
    (dispatch, getState) => {
        dispatch(setLoadingUser(loading));
        API.getUserCurrent()
            .then((res) => {
                dispatch(setUser(res.data));
            })
            .finally(() => {
                dispatch(setLoadingUser(false));
            });
    };

export const isAdmin = () => (dispatch, getState) => {
    if (getState().user.userData.permissions) return _.findIndex(getState().user.userData.permissions, ['code', 'IS_ADMIN']) > -1;
    else return false;
};

export const isBaAdmin = (type) => (dispatch, getState) => {
    let typeString = type === 'MDU' ? 'MDU' : 'THEATRES';
    if (getState().user.userData.permissions)
        return _.findIndex(getState().user.userData.permissions, ['code', `BA_IS_${typeString}_ADMIN`]) > -1;
    else return false;
};

export const canEnterAdminPage = () => (dispatch, getState) => {
    if (getState().user.userData.permissions) {
        return dispatch(
            hasOneOfPermission(
                [
                    Permissions.CAN_ACCESS_MERGES_PAGE,
                    Permissions.CAN_MANAGE_PINS,
                    Permissions.CAN_ACCESS_PIN_ADMIN,
                    Permissions.CAN_ACCESS_HL7DASHBOARD,
                    Permissions.CAN_ACCESS_FHIR_DASHBOARD,
                    Permissions.CAN_ACCESS_DICTIONARIES,
                    Permissions.CAN_ACCESS_REPORTS,
                    Permissions.CAN_ADD_ANNOUNCEMENT,
                    Permissions.AGYLE_CAN_CONFIG_SYSTEM,
                    Permissions.AGYLE_CAN_ACCESS_MCT_ADMIN,
                    Permissions.CAN_VIEW_PATIENT_RECORD,
                    Permissions.CAN_ACCESS_ADMIN_PAGE,
                    Permissions.CAN_ACCESS_STATISTICS,
                ],
                // ['CAN_ACCESS_ADMIN_PAGE','CAN_ACCESS_MERGES_PAGE','CAN_ACCESS_HL7DASHBOARD',
                //     'CAN_ACCESS_DICTIONARIES','CAN_ADD_ANNOUNCEMENT']
            ),
        );
    } else return false;
};

export const canUpload = () => (dispatch, getState) => {
    if (getState().user.userData.permissions)
        return _.findIndex(getState().user.userData.permissions, ['code', 'CAN_UPLOAD_DOCUMENT']) > -1 || dispatch(isAdmin());
    else return false;
};

export const canDownloadDoc = () => (dispatch, getState) => {
    if (getState().user.userData.permissions)
        return _.findIndex(getState().user.userData.permissions, ['code', 'CAN_PRINT_DOCUMENT']) > -1 || dispatch(isAdmin());
    else return false;
};

export const hasPermission = (permission) => (dispatch, getState) => {
    if (getState().user.userData.permissions) {
        return _.findIndex(getState().user.userData.permissions, ['code', permission]) > -1;
    } else return false;
};

export const hasBAPermission = (permission, type) => (dispatch, getState) => {
    if (getState().user.userData.permissions) {
        //console.log("All user permissions (BA)",getState().user.userData.userName, _.filter(getState().user.userData.permissions));
        return _.findIndex(getState().user.userData.permissions, ['code', permission]) > -1 || dispatch(isBaAdmin(type));
    } else return false;
};

export const hasAllPermission = (permissions) => (dispatch, getState) => {
    if (Array.isArray(permissions) && permissions.length === 0) {
        console.error('hasAllPermissions error.No permission list input.');
        return false;
    }
    let supportedPerms = [];
    permissions.forEach((prm) => {
        if (Permissions.PERMISSIONS_LIST.includes(prm)) {
            supportedPerms.push(prm);
        } else {
            console.log('Permission ' + prm + ' not in supported list.');
        }
    });
    if (supportedPerms.length !== permissions.length) {
        console.log('supportedPerms', supportedPerms, 'input permissions', permissions, 'Not all supported!');
    }
    if (getState().user.userData.permissions)
        return (
            _.filter(getState().user.userData.permissions, function (perm) {
                return supportedPerms.includes(perm.code);
            }).length === supportedPerms.length
        );
    else return false;
};

export const hasOneOfPermission = (permissions) => (dispatch, getState) => {
    if (Array.isArray(permissions) && permissions.length === 0) {
        console.error('hasOneOfPermissions error.No permission list input.');
        return false;
    }
    let supportedPerms = [];
    permissions.forEach((prm) => {
        if (Permissions.PERMISSIONS_LIST.includes(prm)) {
            supportedPerms.push(prm);
        } else {
            console.log('Permission ' + prm + ' not in supported list.');
        }
    });
    if (getState().user.userData.permissions) {
        let fltr = _.filter(getState().user.userData.permissions, function (perm) {
            //console.log("FILTER", supportedPerms, perm.code, supportedPerms.includes(perm.code));
            return supportedPerms.includes(perm.code);
        });
        //console.log("FILTERED", fltr);
        return fltr.length > 0;
    } else return false;
};

/**
 * Sends a user audit event to the API.
 *
 * @param {Object} patient - The patient object containing patient details.
 * @param {Object|string} auditAction - The audit action, either as an object with `action` and `description` properties, or as a string representing the action.
 * @param {Object} [otherData={}] - Additional data to include in the audit event.
 * @returns {Function} A thunk function that, when executed, sends the audit data to the API.
 */
export const sendUserAudit =
    (patient, auditAction, otherData = {}) =>
    () => {
        let action, description;

        if (typeof auditAction === 'object' && auditAction?.action && auditAction?.description) {
            ({ action, description } = auditAction);
        } else if (typeof auditAction === 'string') {
            action = auditAction;
            description = 'N/A';
        } else {
            console.error('Invalid auditAction:', auditAction);
            return;
        }

        const auditData = {
            action,
            description,
            patient: patient?.patient?.__id || null,
            patientInWard: patient?.__id || null,
            attendance: patient?.admission?.__id || null,
            ...otherData,
        };

        API.audit(auditData).catch((error) => {
            console.error('API Audit Error', error);
        });
    };

export const sendOpenDocumentAudit = (patientId, documentId, reportGroupId) => (dispatch, getState) => {
    API.eyonixAudit(4, {
        patientId: patientId,
        documentId: documentId,
        data: reportGroupId,
    }).catch((error) => {
        console.error('API Audit Error', error);
    });
};

export default userSlice.reducer;
